import { h3CSS } from '@/uiComposites/typography/headings';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { stack } from '@/uiPrimitives/layout/stack';
import { textBlock } from '@/uiPrimitives/typography/text';
import { useCallback } from 'react';
import { translateInline } from '@/globals/translate/translateInline';
import { addTestSelector } from '@dop/shared/helpers/testSelector';

export const SubmitMessage = () => {
	const submitMessageRef = useCallback((node: HTMLDivElement) => {
		if (node != null) node.scrollIntoView();
	}, []);

	return (
		<div
			ref={submitMessageRef}
			className={classes(
				box({
					backgroundColor: 'negativeBlue',
					padding: '4 | betweenListItems',
				}),
			)}
		>
			<div className={classes(stack({ rowGap: '5 | betweenParagraphs' }))}>
				<h2
					className={classes(h3CSS)}
					{...addTestSelector('uiTitleMessageSent')}
				>
					{translateInline({
						en: 'Your message has been sent',
						nl: 'Uw bericht is verstuurd',
					})}
				</h2>
				<p className={classes(textBlock({}))}>
					{translateInline({
						en: 'Thank you very much for your inquiry. We will try to respond to your request within 2 working days.',
						nl: 'Bedankt voor uw reactie. Wij nemen zo snel mogelijk contact met u op.',
					})}
				</p>
			</div>
		</div>
	);
};
